//
import AccountModel from '@/models/Accounting/AccAccount'

const fetchAllParents = async () => {
    try {
        let response = await AccountModel.where('root', 1)
            .params({ get_all_results: true })
            .get()
        return response
    } catch (error) {
        return error.response
    }
}

//
export default  fetchAllParents 
